import React from 'react';
import "../Styles/DarkEffect.css"

const DarkEffect = (props) => {
    return (
        <div className='DarkEffect' ></div >
    )
}

export default DarkEffect;